import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrowser = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "outline-flat",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 64 64",
	"aria-hidden": "true",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: currentColor;\n        stroke-width: 0px;\n      }\n    " }) }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 36,
				y: 48.5,
				width: 24,
				height: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M48,63.5c-7.44,0-13.5-6.06-13.5-13.5s6.06-13.5,13.5-13.5,13.5,6.06,13.5,13.5-6.06,13.5-13.5,13.5ZM48,39.5c-5.79,0-10.5,4.71-10.5,10.5s4.71,10.5,10.5,10.5,10.5-4.71,10.5-10.5-4.71-10.5-10.5-10.5Z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M48,63.5c-4.31,0-6.64-6.96-6.64-13.5s2.33-13.5,6.64-13.5,6.64,6.96,6.64,13.5-2.33,13.5-6.64,13.5ZM48,39.5c-1.45,0-3.64,4.19-3.64,10.5s2.19,10.5,3.64,10.5,3.64-4.19,3.64-10.5-2.19-10.5-3.64-10.5Z"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 6,
				y: 9.5,
				width: 42,
				height: 3
			}),
			/* @__PURE__ */ _jsx("rect", {
				className: "cls-1",
				x: 4.5,
				y: 49.5,
				width: 27,
				height: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "cls-1",
				d: "M35.5,63.5H11c-3.58,0-6.5-2.92-6.5-6.5V7C4.5,3.42,7.42.5,11,.5h32c3.58,0,6.5,2.92,6.5,6.5v26.5h-3V7c0-1.93-1.57-3.5-3.5-3.5H11c-1.93,0-3.5,1.57-3.5,3.5v50c0,1.93,1.57,3.5,3.5,3.5h24.5v3Z"
			})
		] })
	]
});
export default SvgBrowser;
